import React from "react";
import IconFacebook from "./IconFacebook";
import IconInstagram from "./IconInstagram";
import IconLinkedin from "./IconLinkedin";
import IconTwitter from "./IconTwitter";
import IconYoutube from "./IconYoutube";

interface IconSocial {
  type: "Facebook" | "Instagram" | "Twitter" | "Youtube" | "Linkedin";
}

const IconSocial: React.FC<IconSocial> = (props: IconSocial) => {
  const { type } = props;

  switch (type) {
    case "Twitter":
      return <IconTwitter />;
    case "Youtube":
      return <IconYoutube />;
    case "Linkedin":
      return <IconLinkedin />;
    case "Instagram":
      return <IconInstagram />;
    case "Facebook":
    default:
      return <IconFacebook />;
  }
};

export default IconSocial;
